var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('UserList',{attrs:{"users":_vm.users},on:{"changeUser":_vm.changeUser}}),_c('router-view',{ref:"list",attrs:{"hasList":_vm.hasList,"parent":_vm.parent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }